import React from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@mui/material";
import {
  Assignment,
  Groups,
  HealthAndSafety,
  Engineering,
  AccountTree,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import PageWithHeader from "../common/PageWithHeader";

const COMS_NAVY = "#123456";

interface Module {
  label: string;
  description: string;
  path: string;
  icon: React.ReactElement;
}

const MODULES: Module[] = [
  {
    label: "Daily Site Report",
    description:
      "Log and manage daily construction site reports by project block.",
    path: "/coms/daily-site-report",
    icon: <Assignment sx={{ fontSize: 56, color: COMS_NAVY }} />,
  },
  {
    label: "Labour Tracker",
    description:
      "Track labour resources, attendance and productivity across sites.",
    path: "/coms/labour-tracker",
    icon: <Groups sx={{ fontSize: 56, color: COMS_NAVY }} />,
  },
  {
    label: "SHEQ",
    description: "Safety, Health, Environment and Quality management on site.",
    path: "/coms/sheq",
    icon: <HealthAndSafety sx={{ fontSize: 56, color: COMS_NAVY }} />,
  },
  {
    label: "ProTrack",
    description: "Track project programme milestones, snag lists and unit handovers.",
    path: "/coms/protrack",
    icon: <AccountTree sx={{ fontSize: 56, color: COMS_NAVY }} />,
  },
];

const ComsLanding: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PageWithHeader>
      {/* Header */}
      <Box sx={{ bgcolor: COMS_NAVY, color: "#fff", px: 5, py: 4 }}>
        <Box display="flex" alignItems="center" gap={2}>
          <Engineering sx={{ fontSize: 44 }} />
          <Box>
            <Typography variant="h1" sx={{ color: "#fff", fontWeight: 700 }}>
              COMS
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
              Construction Operations Management System
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Module cards */}
      <Box px={5} py={5}>
        <Typography
          variant="h2"
          sx={{ color: COMS_NAVY, fontWeight: 600, mb: 4 }}
        >
          Modules
        </Typography>
        <Box display="flex" flexWrap="wrap" gap={4}>
          {MODULES.map((mod) => (
            <Card
              key={mod.path}
              sx={{
                width: 260,
                borderRadius: 3,
                boxShadow: "0 2px 12px rgba(18,52,86,0.12)",
                transition: "0.2s",
                "&:hover": {
                  boxShadow: "0 6px 24px rgba(18,52,86,0.22)",
                  transform: "translateY(-3px)",
                },
              }}
            >
              <CardActionArea
                onClick={() => navigate(mod.path)}
                sx={{ p: 3, textAlign: "center", minHeight: 220 }}
              >
                <CardContent>
                  {mod.icon}
                  <Typography
                    variant="h6"
                    sx={{ mt: 2, color: COMS_NAVY, fontWeight: 700 }}
                  >
                    {mod.label}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 1 }}
                  >
                    {mod.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Box>
      </Box>
    </PageWithHeader>
  );
};

export default ComsLanding;
